"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimer = void 0;
var react_1 = require("react");
var useTimer = function (func, duration) {
    var timeoutId = (0, react_1.useRef)(null);
    var isClosed = (0, react_1.useRef)(false);
    var action = (0, react_1.useCallback)(function () {
        if (!isClosed.current) {
            func();
        }
    }, [func]);
    (0, react_1.useEffect)(function () { return function () {
        isClosed.current = true;
    }; }, []);
    if (timeoutId.current !== null) {
        clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(action, duration);
};
exports.useTimer = useTimer;
